<template>
  <v-data-table
    :items-per-page="totalPageEmpenhoStart"
    :headers="headers"
    :items="itensCarregados"
    item-key="id"
    sort-by="numero_item"
    class="mt-2 c-table-empenho"
    :loading="loading"
    :search="search"
    hide-default-header
  >
    <template v-slot:top>
      <v-toolbar flat prominent class="mb-5">
        <v-row class="justify-center align-center">

          <v-col class="mb-0 pb-0" cols="12" sm="12" md="4">
            <v-text-field
              outlined
              readonly
              label="Saldo do Pregão"
              prefix="Saldo:"
              :value="saldoTotalPregao | dinheiro">
            </v-text-field>
          </v-col>

          <v-col class="mb-0 pb-0" cols="12" sm="12" md="4">
            <v-text-field
              class="ml-3"
              outlined
              readonly
              label="Valor do Empenho"
              prefix="Atual:"
              :value="valorTotalEmpenho | dinheiro">
            </v-text-field>
          </v-col>

          <v-col class="mb-0 pb-0" cols="12" sm="12" md="5">
            <v-text-field
              hint="Busque Por: Nome do Produto"
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar produto"
              single-line>
            </v-text-field>
          </v-col>

        </v-row>
        <v-dialog v-model="dialogEditarValoresStart" max-width="800px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Definir Quantidade do Empenho</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col class="mb-0 pb-0" cols="12" sm="12" md="7">
                    <v-text-field
                      disabled
                      :value="`${editedItem.numero_item || '-'} - ${editedItem.descricao_edital || 'Sem descrição do item'}`"
                      outlined
                      label="Item do Pregão"
                    ></v-text-field>
                  </v-col>
                  <v-col class="mb-0 pb-0" cols="12" sm="12" md="5">
                    <v-text-field disabled :value="editedItem.name" outlined label="Produto"></v-text-field>
                  </v-col>
                  <v-col class="mb-0 pb-0" cols="12" sm="12" md="3">
                    <v-text-field label="Quantidade Disponível" disabled type="number" :value="editedItem.quantidade_restante" outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      class="u-clear-data"
                      :rules="rulesQuantidade"
                      outlined
                      type="number"
                      v-model.number="editedItem.quantEmpenho"
                      label="Quantidade a Empenhar">
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="btn-cancelar" color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn
                v-if="editedItem.quantEmpenho > editedItem.quantidade_restante"
                color="blue darken-1" text disabled>Salvar</v-btn>
              <v-btn v-else color="blue darken-1" text @click="salveItemEmpenho">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <!-- Produto + imagem -->
    <template #item.imageUrl="{ item }">
      <img class="mt-3 mb-0 rounded-lg elevation-1" :src="item.imageUrl" alt="Imagem" width="70px" height="auto" /><br />
      <p class="c-table__meta c-table__meta--principal ma-0 pa-0">
        {{ item.numero_item || "-" }} - {{ item.descricao_edital || "Sem descrição do item" }}
      </p>
      <p class="c-table__meta ma-0 pa-0">
        {{ item.name }} | {{ obterRotuloUnidade(item.tipoUnidade) }}
      </p>
    </template>

    <template #item.valor_unitario_compra="{ item }">
      <v-currency-field readonly class="c-table-empenho__item" prefix="R$" :value="item.valor_unitario_compra" hint="VALOR DE COMPRA" persistent-hint disabled />
    </template>

    <template #item.valor_unitario_venda="{ item }">
      <v-text-field class="c-table-empenho__item" hint="VALOR DE VENDA NO PREGÃO" persistent-hint disabled :value="item.valor_unitario_venda | dinheiroDecimal"></v-text-field>
    </template>

    <template #item.quantidade="{ item }">
      <v-text-field class="c-table-empenho__item" disabled type="number" :value="item.quantidade" hint="QTD ORIGINAL" persistent-hint></v-text-field>
    </template>

    <template #item.quantidade_restante="{ item }">
      <v-text-field class="c-table-empenho__item" color="blue" disabled type="number" :value="item.quantidade_restante" hint="SALdo RESTANTE" persistent-hint></v-text-field>
    </template>

    <template #item.valorTotal="{ item }">
      <v-text-field class="c-table-empenho__item" disabled :value="(item.quantidade * item.valor_unitario_venda) | dinheiro" hint="VALOR TOTAL" persistent-hint></v-text-field>
    </template>

    <template #item.quantEmpenho="{ item }">
      <v-text-field color="#943634" readonly class="u-clear-data c-table-empenho__item" type="number" v-model.number="item.quantEmpenho" hint="QUANTIDADE DO EMPENHO" persistent-hint></v-text-field>
    </template>

    <template #item.valorItemEmpenho="{ item }">
      <v-text-field class="u-clear-data c-table-empenho__item" hint="VALOR DO EMPENHO" persistent-hint disabled :value="(item.quantEmpenho * item.valor_unitario_venda) | dinheiro"></v-text-field>
    </template>

    <template v-slot:[`item.actions`]="{ item }">
      <div class="text-center d-flex">
        <v-btn class="mx-2" fab dark x-small color="#943634">
          <v-icon dark @click="editValoresEmpenho(item)">mdi-pencil</v-icon>
        </v-btn>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import axios from "axios";
import { urlApi, showError } from "@/global";
import barramento from "@/barramento";
import { obterRotuloTipoUnidade } from "@/utils/tiposUnidade";

export default {
  name: "ListaProdutosEmpenhoStart",
  props: {
    pregaoId: { type: [Number, String], required: true }
  },
  data() {
    return {
      loading: true,
      search: "",
      dialogEditarValoresStart: false,
      itensCarregados: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      totalPageEmpenhoStart: -1,
      headers: [
        { text: "Imagem", align: "start", sortable: false, value: "imageUrl" },
        { class: "u-hide", cellClass: "u-hide", text: "Produto", value: "name" },
        { class: "u-hide", cellClass: "u-hide", text: "N°Item", value: "numero_item" },
        { class: "u-hide", cellClass: "u-hide", text: "Un. de Medida", value: "tipoUnidade" },
        { text: "Valor de Compra", value: "valor_unitario_compra" },
        { text: "Valor Cadastrado", value: "valor_unitario_venda" },
        { text: "Qtd Original", value: "quantidade" },
        { text: "Saldo Restante", value: "quantidade_restante" },
        { text: "Valor Total", value: "valorTotal" },
        { text: "Qtd. do Empenho", value: "quantEmpenho" },
        { text: "Valor do Empenho", value: "valorItemEmpenho" },
        { text: "Ação", value: "actions", sortable: false }
      ],
      rulesQuantidade: [
        value => value <= (this.editedItem.quantidade_restante || 0) || 'Quantidade superior ao saldo'
      ],
    };
  },
  computed: {
    saldoTotalPregao() {
      return this.itensCarregados.reduce((a, it) => a + (it.quantidade * it.valor_unitario_venda), 0);
    },
    valorTotalEmpenho() {
      return this.itensCarregados.reduce((a, it) => a + ((it.quantEmpenho || 0) * it.valor_unitario_venda), 0);
    }
  },
  watch: {
    valorTotalEmpenho(val) {
      barramento.EnviarTotalEmpenho(val);
    },
    pregaoId: {
      immediate: true,
      handler(id) {
        if (id) this.carregarItens();
      }
    }
  },
  methods: {
    async carregarItens() {
      this.loading = true;
      try {
        const res = await axios.get(`${urlApi}/pregao/${this.pregaoId}/item`);

        this.itensCarregados = res.data
          .filter(it => it.quantidade_restante > 0)
          .map(it => ({
            ...it,
            tipoUnidade: it.tipoUnidade !== undefined ? it.tipoUnidade : it.tipo_unidade,
            quantEmpenho: 0,
          }));
        this.sincronizarComBarramento();
      } catch (err) {
        showError(err);
      } finally {
        this.loading = false;
      }
    },

    sincronizarComBarramento() {
      barramento.EnviarProdutosEmpenho(this.itensCarregados, true);
    },

    editValoresEmpenho(item) {
      this.editedIndex = this.itensCarregados.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogEditarValoresStart = true;
    },

    close() {
      this.dialogEditarValoresStart = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    salveItemEmpenho() {
      if (this.editedIndex > -1) {
        Object.assign(this.itensCarregados[this.editedIndex], this.editedItem);
        this.sincronizarComBarramento();
      }
      this.close();
    },

    obterRotuloUnidade(tipoUnidade) {
      return obterRotuloTipoUnidade(tipoUnidade);
    },
  },
  mounted() {
    if (this.pregaoId) this.loading = false;
  },
};
</script>

<style>
.c-table-empenho__item { width: 90px; }
.c-table-empenho .v-messages__message { font-size: x-small; font-weight: 700; }
.c-table__meta { margin-bottom: 0; font-size: 0.875rem; line-height: 1.2rem; color: rgba(0, 0, 0, 0.72); }
.c-table__meta--principal { font-weight: 500; color: rgba(0, 0, 0, 0.87); }
</style>
